export const parseItemID = (id: string | undefined) => {
  return id ? `item-${id}` : undefined;
};
